<div class="custom-inspection-item">
  <mat-icon [inline]="true" cdkDragHandle class="custom-inspection-item__icon">drag_indicator</mat-icon>

  <mat-checkbox
    color="primary"
    [ngModel]="item.inspectionItemChecked"
    (ngModelChange)="itemCheckedChange($event)"
  ></mat-checkbox>
  <div
    #itemName
    [attr.contenteditable]="editMode"
    class="custom-inspection-item__text nowrap fs s14 text-color gray"
    (click)="enterEditMode()"
    (blur)="leaveEditMode(itemName.textContent)"
    (keydown)="nameChanged($event)"
  >
    {{ item.inspectionItemName }}
  </div>

  <button class="remove" mat-icon-button (click)="removeClick()">
    <app-icon [svg]="EIcon.BB_TRASH"></app-icon>
  </button>
</div>
